import React from 'react'
import { BackEllipseContainer, EllipseGroupContainerPosition, GroupEllipsesContainer } from './styles'
import { GroupSummaryTooltip } from './groupSummaryTooltip'
import { HealthProcedureVariantProps } from '~/constants'
import { EllipseButton } from '~/components/shared'
import { IHealthProcedures, IHealthProceduresOmics } from '~/interfaces'

interface GroupEllipsesProps {
  healthProcedures: IHealthProceduresOmics[]
}

const GroupEllipses = ({ healthProcedures }: GroupEllipsesProps) => {
  const getOneEventPerType = (healthProcedures: IHealthProceduresOmics[]): IHealthProceduresOmics[] => {
    const healthProceduresByType = healthProcedures.reduce<IHealthProceduresOmics[]>((acc, healthProcedure) => {
      const type = healthProcedure.type
      const existentTypes = acc.map(healthProcedure => healthProcedure.type)

      if (existentTypes.includes(type)) return acc
      return [...acc, healthProcedure]
    }, [])

    return healthProceduresByType
  }

  const verifyIfHasAlert = (healthProcedures: IHealthProcedures[]): boolean => {
    return healthProcedures.some(healthProcedure => healthProcedure.isAltered)
  }

  return (
    <GroupEllipsesContainer>
      {getOneEventPerType(healthProcedures).map((passage: IHealthProceduresOmics, index: number) => {
        const ellipseVariant = HealthProcedureVariantProps[passage.type]
        const firstEllipse = index === 0

        const ellipse = () => {
          return (
            <EllipseButton
              key={`${passage.id}-ellipse`}
              alert={firstEllipse ? verifyIfHasAlert(healthProcedures) : false}
              color={ellipseVariant.color}
              quantity={firstEllipse ? healthProcedures.length : undefined}
              iconName={firstEllipse ? 'layerGroup' : ellipseVariant.iconName}
            />
          )
        }

        if (firstEllipse) return ellipse()
        return (
          <BackEllipseContainer key={passage.id} indexEllipse={index}>
            {ellipse()}
          </BackEllipseContainer>
        )
      })}
    </GroupEllipsesContainer>
  )
}

export interface TimelineEllipseGroupButtonProps {
  healthProcedures: IHealthProceduresOmics[]
  position: number
  onClick: (omics: IHealthProceduresOmics[]) => void
}

export const TimelineEllipseGroupButton = ({
  healthProcedures,
  position,
  onClick
}: TimelineEllipseGroupButtonProps): JSX.Element => {
  return (
    <EllipseGroupContainerPosition position={position} onClick={() => onClick(healthProcedures)}>
      <GroupSummaryTooltip medicalEvents={healthProcedures} onClick={onClick}>
        <GroupEllipses healthProcedures={healthProcedures} />
      </GroupSummaryTooltip>
    </EllipseGroupContainerPosition>
  )
}
